module.exports = __webpack_public_path__ + "img/max-cloud-configure.67c6f6f9.svg";